(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-to-reviews-functionality"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('DOMContentLoaded', function () {
    console.log('DEBUG: Sticky Scroll Section: Initializing scroll functionality');

    const sourceElement = document.getElementById('reviews-badge-trigger') || document.getElementById('reviews-badge-container');
    const rightScrollContainer = document.getElementById('right__inner--shd');
    const targetElementDesktop = document.getElementById('judgeme_product_reviews-web');
    const targetElementMobile = document.getElementById('judgeme_product_reviews-mob');
    const restoreTriggerSection = document.getElementById('restore-sticky-trigger');

    if (sourceElement) {
      sourceElement.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        
        console.log('DEBUG: Click triggered');

        // Select the reviews accordion button
        const reviewsAccordionButton = document.getElementById('reviews-accordion-button-web');
        const reviewsAccordionButtonMobile = document.getElementById('reviews-accordion-button-mob');
        if (reviewsAccordionButtonMobile) {
          // Only click if the accordion is not already expanded
          const accordionIsActiveMobile = reviewsAccordionButtonMobile.classList.contains('active-display');
          if (!accordionIsActiveMobile) {
            // Simulate a click event to expand the accordion
            reviewsAccordionButtonMobile.click();
          } else {
            console.log("DEBUG: Reviews accordion mobile already expanded, no need to click.");
          }
        } else {
          console.warn("DEBUG: Reviews accordion button mobile not found.");
        }
        if (reviewsAccordionButton) {
          // Only click if the accordion is not already expanded
          const accordionIsActive = reviewsAccordionButton.classList.contains('active-display');
          if (!accordionIsActive) {
            // Simulate a click event to expand the accordion
            reviewsAccordionButton.click();
          } else {
            console.log("DEBUG: Reviews accordion already expanded, no need to click.");
          }
        } else {
          console.warn("DEBUG: Reviews accordion button not found.");
        }

        const screenWidth = window.innerWidth;

        if (screenWidth >= 992 && rightScrollContainer && targetElementDesktop && restoreTriggerSection) {
          console.log('DEBUG: Large screen — removing sticky and scrolling to target');
          const computedPosition = window.getComputedStyle(rightScrollContainer).position;
          rightScrollContainer.style.position = 'static';

          setTimeout(() => {
            const targetOffset = targetElementDesktop.getBoundingClientRect().top + window.scrollY - 160;
            window.scrollTo({ top: targetOffset, behavior: 'smooth' });

            let scrollTimeout;
            function onScrollEnd() {
              clearTimeout(scrollTimeout);
              scrollTimeout = setTimeout(() => {
                console.log('DEBUG: Scroll finished — setting up observer');
                const observer = new IntersectionObserver((entries) => {
                  entries.forEach(entry => {
                    if (entry.isIntersecting) {
                      console.log('DEBUG: Trigger section visible — restoring sticky');
                      rightScrollContainer.style.position = computedPosition || 'sticky';
                      observer.disconnect();
                      window.removeEventListener('scroll', onScrollEnd);
                    }
                  });
                }, { threshold: 0.1 });

                observer.observe(restoreTriggerSection);
              }, 150);
            }

            window.addEventListener('scroll', onScrollEnd, { passive: true });
          }, 50);
        } 
        
        else if (screenWidth < 992 && targetElementMobile) {
          console.log('DEBUG: Small screen — simple scroll to mobile target');
          const headerOffset = 150; // adjust if your header overlaps content
          const targetOffset = targetElementMobile.getBoundingClientRect().top + window.scrollY - headerOffset;

          window.scrollTo({ top: targetOffset, behavior: 'smooth' });
        } 
        
        else {
          console.warn('DEBUG: Scroll target not found for current screen size.');
        }
      });
    } else {
      console.warn('DEBUG: Click source element not found.');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
